import React, { Component } from 'react';

export default class ArrowSticker extends Component{
    state={

    };
    constructor(props) {
        super(props);
    };
    render(){
        return  <div className='arrow-sticker' onMouseEnter={this.mouseIn} onMouseLeave={this.mouseOut}
                     onClick={this.onClick}>
            {this.getTop()}
            <div className={this.state.hover?'arrow-sticker-text-on':'arrow-sticker-text'}>
                <p className='text-p'>{this.getText()}</p>
            </div>
            {this.getBottom()}
        </div>
    }
    getText=()=>{
        return this.state.isOn? this.props.textOff :this.props.text;
    };
    getBottom=()=>{
        return this.state.isOn?"": <div className={this.state.hover?'arrow-down-on':'arrow-down'}></div>;
    };
    getTop=()=>{
        return this.state.isOn? <div className={this.state.hover?'arrow-up-on':'arrow-up'}></div>:"";
    };
    onClick=()=>{
        if(this.state.isOn){
            this.props.off();
            this.setState({isOn: false});
            return;
        }
        this.props.on();
        this.setState({isOn: true});
    };
    mouseIn=()=>{this.setState({hover: true});};
    mouseOut=()=>{this.setState({hover: false});};
}
